import React, { useState, useEffect, createContext } from 'react';
import api from '../services/api'
import app from '../firebase/config';

import { ToastContainer, toast } from 'react-toastify';

export const CategorysContext = createContext({});

function CategorysProvider({ children }) {
    const [modalEditValueId, setModalEditValueId] = useState()
    const [showModalEdit, setShowModalEdit] = useState()
    const [modalEditValue, setModalEditValue] = useState()
    const [animation, setAnimation] = useState(false)
    const [categoryName, setCategoryName] = useState()
    const [categorys, setCategorys] = useState([])
    const [subCategorys, setSubCategorys] = useState([])
    const [modalEditImage, setModalEditImage] = useState()
    const [modalEditName, setModalEditName] = useState()
    const [categoryById, setCategoryById] = useState()
    const [subCategoryName, setSubCategoryName] = useState()
    const [showModalSubCategory, setShowModalSubCategory] = useState(false)
    const [animatedBtn,setAnimatedBtn] = useState(false)

    const storage = async (name) => {

        setAnimation(true)
        const response = await api.post("/panel/storage/category/menu", {
            "name": name,
        })
        if (response.status == 200) {

            toast.success("Categoria adicionada com sucesso!", {
                autoClose: 1200
            })
            setAnimation(false)
            setTimeout(() => {
                getAll()
            }, (1200));

        }

    }
    const storageSubCategory = async (subCategory, image, category) => {

        if (!subCategory) {
            toast.error("Informe um nome")
        }
        if (!image) {
            toast.error("Informe uma imagem")
        }

        if (!category) {
            toast.error("Informe uma categoria")
        }

        setAnimation(true)

        const imageData = await getImageFirebase(image)

        const response = await api.post("/category/sub/", {
            "name": subCategory,
            "image": imageData,
            "category": category,
        })

        if (response.status == 200) {
            toast.success("Sub Categoria adicionada com sucesso!", {
                autoClose: 1200
            })
            setAnimation(false)
            getSubCategorys()
        }

    }
    const removeSubCategory = async (id) => {

        const response = await api.post("category/delete/sub", {
            id: id
        })
        if (response.status == 200) {
            toast.success("Sub categoria removida com sucesso!", {
                autoClose: 1200
            })
            getSubCategorys()
        }

    }
    const getAll = async () => {
        setAnimation(true)
        const response = await api.get("panel/get/all/categorys/menu")
        if (response.status == 200) {
            setCategorys(response.data)
            setAnimation(false)
        }else{
        setAnimation(true)
        }
        

    }
    const get = async (name) => {
        const response = await api.get(`/category/get/${name}`)
        if (response.status == 200) {
            setCategorys(response.data)
            return false
        }
        getAll()

    }
    const getSubCategory = async (name) => {

        if (name == "") {
            getSubCategorys()
            return
        }

        const response = await api.get(`/category/sub/by/id/${name}`)
        if (response.status == 200) {
            setSubCategorys(response.data)
            return false
        }

        getSubCategorys()


    }
    const getById = async (id) => {
        const response = await api.get(`/category/get/by/id/${id}`)
        console.log(response.data)
        if (response.status == 200) {
            setCategoryById(response.data)
        }

    }
    const getSubCategorys = async () => {
        setAnimation(true)
        const response = await api.get("/category/sub/all/categorys")

        if (response.status == 200) {
            setSubCategorys(response.data)
            setAnimation(false)
        }else{
            setAnimation(false)
        }
    }
    const remove = async (id) => {
        setAnimation(true)
        const response = await api.post("panel/delete/menu/category", {
            id: id
        })

        if (response.status == 200) {
            getAll()
            toast.success("Categoria removida com sucesso!", {
                autoClose: 1200
            })
            setAnimation(false)

        }
    }
    const edit = async (field, value, id) => {
        const response = await api.put("panel/update/category/menu", {
            id: modalEditValueId,
            field,
            value,
            olter_value: categoryName
        });

        toast.success("Categoria editada com sucesso!", {
            autoClose: 1200
        })

        getAll()
    }
    const updateSubCategory = async (field, value, id) => {
        setAnimatedBtn(true)
        const response = await api.put("panel/sub/category/", {
            id: modalEditValueId,
            field,
            value,
            olter_value: categoryName
        });

        if (response.status == 200) {
        getSubCategorys()
        setAnimatedBtn(false)    
    }else{
        setAnimatedBtn(false)
    }
        

    }
    const getImageFirebase = async (image) => {
        try {
            const uploadTask = await app.storage().ref(`/categorys/${image.name}`).put(image);
            const imageUrl = await app.storage().ref(`/categorys/${image.name}`).getDownloadURL();
            return imageUrl;
        } catch (error) {
            // Exibe o erro no console
            console.error("Erro ao enviar a imagem ou obter a URL:", error);

            // Pode-se exibir um alerta para o usuário
        }
    };

    useEffect(() => {
        getAll()
        getSubCategorys()
    }, [])

    return (
        <CategorysContext.Provider value={{
            storage,
            get,
            getSubCategorys,
            getAll,
            categorys,
            subCategorys,
            setCategoryName,
            categoryName,
            remove,
            edit,
            animation,
            setShowModalEdit,
            showModalEdit,
            setModalEditValue,
            modalEditValue,
            setModalEditValueId,
            modalEditValueId,
            setModalEditImage,
            modalEditImage,
            setModalEditName,
            modalEditName,
            getById,
            categoryById,
            setSubCategoryName,
            subCategoryName,
            updateSubCategory,
            storageSubCategory,
            setShowModalSubCategory,
            showModalSubCategory,
            removeSubCategory,
            getSubCategory,
            setAnimatedBtn,
            animatedBtn
        }}>
            {children}
        </CategorysContext.Provider>
    );
}

export default CategorysProvider;
